import ConnectionPathPlugin from 'rete-connection-path-plugin'

import CONST_SOCKET from '../const/socket'
import CONST_COMPONENT from '../const/component'

import AutoArrange from '../plugins/backend/AutoArrange'
import OtherListeners from '../plugins/backend/OtherListeners'
import TogglingConnections from '../plugins/backend/TogglingConnections'
import RemovingConnections from '../plugins/backend/RemovingConnections'

export default [
  // { name: 'nodeHover', plugin: HoverOverNode },
  { 
    name: 'custom-auto-arrange', 
    plugin: AutoArrange,
    options: { margin: { x: 50, y: 10 }, depth: 0 }
  },
  { 
    name: 'connection-path', 
    plugin: ConnectionPathPlugin, 
    options: {
      type: ConnectionPathPlugin.DEFAULT, // DEFAULT or LINEAR transformer
      // transformer: () => ([x1, y1, x2, y2]) => [[x1, y1], [x2, y2]], // optional, custom transformer
      curve: ConnectionPathPlugin.curveBundle, // curve identifier
      // options: { vertical: false, curvature: 0.4 }, // optional
      arrow: { color: '#0D8BF1', marker: 'M5,-7 L5,7 L25,0 z' }
    } 
  },
  { 
    name: 'otherListeners', 
    plugin: OtherListeners 
  },

  { 
    name: 'removingButtonConnections', 
    plugin: RemovingConnections, 
    options: { 
      name: CONST_COMPONENT.BUTTON,
      havingUnmatch: ['new_post_back'],
    },
  },
  
  { 
    name: 'removingQuickReplyConnections', 
    plugin: RemovingConnections, 
    options: { 
      name: CONST_COMPONENT.QUICK_REPLY,
      havingUnmatch: ['newPostback'],
    },
  },
  
  { 
    name: 'togglingAudioConnection', 
    plugin: TogglingConnections, 
    options: { 
      name: CONST_COMPONENT.AUDIO, 
      either: CONST_SOCKET.AUDIO_OUTPUT, 
      or: CONST_SOCKET.AUDIO_OUTPUT_QUICKREPLY 
    },
  },

  { 
    name: 'togglingCarouselConnection', 
    plugin: TogglingConnections, 
    options: { 
      name: CONST_COMPONENT.CAROUSEL, 
      either: CONST_SOCKET.CAROUSEL_OUTPUT, 
      or: CONST_SOCKET.CAROUSEL_OUTPUT_QUICKREPLY 
    },
  },

  { 
    name: 'togglingEcommerceConnection', 
    plugin: TogglingConnections, 
    options: { 
      name: CONST_COMPONENT.ECOMMERCE,
      either: CONST_SOCKET.ECOMMERCE_OUTPUT, 
      or: CONST_SOCKET.ECOMMERCE_OUTPUT_QUICKREPLY 
    },
  },

  { 
    name: 'togglingFacebookMediaConnection', 
    plugin: TogglingConnections, 
    options: { 
      name: CONST_COMPONENT.FACEBOOK_MEDIA,
      either: CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT, 
      or: CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_QUICKREPLY 
    },
  },

  { 
    name: 'togglingFileConnection', 
    plugin: TogglingConnections, 
    options: { 
      name: CONST_COMPONENT.FILE,
      either: CONST_SOCKET.FILE_OUTPUT, 
      or: CONST_SOCKET.FILE_OUTPUT_QUICKREPLY 
    },
  },

  { 
    name: 'togglingGenericConnection', 
    plugin: TogglingConnections, 
    options: { 
      name: CONST_COMPONENT.GENERIC_TEMPLATE, 
      either: CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT, 
      or: CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_QUICKREPLY 
    },
  },

  { 
    name: 'togglingImageConnection', 
    plugin: TogglingConnections, 
    options: { 
      name: CONST_COMPONENT.IMAGE, 
      either: CONST_SOCKET.IMAGE_OUTPUT, 
      or: CONST_SOCKET.IMAGE_OUTPUT_QUICKREPLY 
    },
  },

  { 
    name: 'togglingTextConnection', 
    plugin: TogglingConnections, 
    options: { 
      name: CONST_COMPONENT.TEXT, 
      either: CONST_SOCKET.TEXT_OUTPUT, 
      or: CONST_SOCKET.TEXT_OUTPUT_QUICKREPLY 
    },
  },

  { 
    name: 'togglingVideoConnection', 
    plugin: TogglingConnections, 
    options: { 
      name: CONST_COMPONENT.VIDEO, 
      either: CONST_SOCKET.VIDEO_OUTPUT, 
      or: CONST_SOCKET.VIDEO_OUTPUT_QUICKREPLY 
    },
  },
]